import * as Models from "../../../Models";
import * as Services from "../../../Services";
import * as _ from "lodash";
export module Igs.Solar.CostCalculation {
    export interface ICloneMarketScope extends ng.IScope {
        cloneMarketCtrl: CloneMarketCtrl;
    }

    export class CloneMarketCtrl {
        public cloneEpcAssumedValuesRequest: Models.CostCalculation.CloneEpcAssumedValuesRequest.ICloneEpcAssumedValuesRequest;

        public static $inject = ['$scope', '$modalInstance', '$state', 'MarketAssumedValuesApiClient', 'assumedValuesModel'];
        constructor(
            public $scope: ICloneMarketScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public $state: angular.ui.IStateService,
            public marketAssumedValuesApiClient: Services.MarketAssumedValuesApiClient.IMarketAssumedValuesApiClient,
            public assumedValuesModel: Models.CostCalculation.MarketAssumedValuesModel.IMarketAssumedValuesModel) {

            $scope.cloneMarketCtrl = this;

            this.cloneEpcAssumedValuesRequest = new Models.CostCalculation.CloneEpcAssumedValuesRequest.CloneEpcAssumedValuesRequest(_.cloneDeep(assumedValuesModel));
        }

        public cloneMarket = (): void => {
            this.marketAssumedValuesApiClient.cloneEpcAssumedValues(this.cloneEpcAssumedValuesRequest)
                .then((clonedAssumedValuesModel: Models.CostCalculation.MarketAssumedValuesModel.IMarketAssumedValuesModel) => {
                    this.$modalInstance.close(clonedAssumedValuesModel);
                });
        }

        public closeModal = (): void => {
            this.$modalInstance.close();
        }

    }
}